import { FC } from "react";

import { HStack, Skeleton, SkeletonCircle } from "@chakra-ui/react";

import { FullWidthVStack } from "@components/common";

import { FAQ_PAGE_LIMIT } from "../constants";
import { TFaqSkeletonProps } from "../types";

const getKey = (i: number): string => `faq-skeleton-${i}`;

const FaqSkeleton: FC<TFaqSkeletonProps> = ({ isLoading, children }) => {
  if (!isLoading) {
    return <>{children}</>;
  }
  return (
    <FullWidthVStack spacing="1.875rem" mb="1.875rem">
      {Array.from({ length: FAQ_PAGE_LIMIT }).map((_, index) => (
        <HStack key={getKey(index)}>
          <SkeletonCircle size="1.625rem" />
          <Skeleton flex="1" height="1.625rem" />
        </HStack>
      ))}
    </FullWidthVStack>
  );
};
export default FaqSkeleton;
